/* eslint-disable nordic/no-img-tags */
const React = require('react');

const { useEffect } = React;

const { Script } = require('nordic/script');
const { Style } = require('nordic/style');
const { Head } = require('nordic/head');
const serialize = require('serialize-javascript');
const { AndesProvider } = require('@andes/context');
const { MelidataTrack } = require('nordic/melidata/melidata-track');
const getNonceScript = require('../../utils/viewabilityScript');

const { SendTracksPromotions, TrackingPath } = require('@services/V2/TrackingService/TrackingService');

const SelectorsMenu = require('./components/SelectorsMenu');
const QcatFilters = require('./components/Filters');
const ItemsList = require('./components/ItemsList');

const { getTranslationsBySite } = require('@pages/V2/translations');
const AdvertisingAdn = require('@app/components/Advertising');

const DesktopView = (props) => {
  const {
    data: {
      selectors,
      items,
      polycardContext,
      availableFilters,
      appliedFilters,
      paging,
      pathFromRoot,
      itemsQuantityLimitToShow,
      smartGroups,
      trackingAds,
      advertising,
    },
    actualLocation,
    country,
    customConfig: { showSelectorsMenu },
    siteId,
    nonce,
    device,
    userId,
    loginUrl,
  } = props;

  useEffect(() => {
    SendTracksPromotions(props);
  }, []);

  const { title = 'Ofertas', smartGroupLinkText } = getTranslationsBySite(siteId);

  return (
    <AndesProvider>
      <div>
        <Head>
          <title>{title}</title>
          <meta name="description" content="Ofertas" />
          <Style href="desktopView.css" critical />
        </Head>
        <MelidataTrack path={TrackingPath.melidata.promotions} isDeferred />
        <Script>
          {`
          window.__PRELOADED_STATE__ = ${serialize(props, { isJSON: true })};
        `}
        </Script>
        <Script src="vendor.js" preload />
        <Script src="desktopView.js" preload />
        <SelectorsMenu
          selectors={selectors}
          actualLocation={actualLocation}
          siteId={siteId}
          showSelectorsMenu={showSelectorsMenu}
        />
        <section className="items-filters-section">
          <div className="sidebar">
            <QcatFilters
              availableFilters={availableFilters}
              appliedFilters={appliedFilters}
              actualLocation={actualLocation}
              paging={paging}
              pathFromRoot={pathFromRoot}
              siteId={siteId}
              itemsQuantityLimitToShow={itemsQuantityLimitToShow}
            />
            {advertising && (
              <div className="advertising">
                <AdvertisingAdn {...advertising} deviceType="desktop" siteId={siteId} device={device} />
              </div>
            )}
          </div>
          <ItemsList
            country={country}
            items={items}
            polycardContext={polycardContext}
            actualLocation={actualLocation}
            appliedFilters={appliedFilters}
            paging={paging}
            smartGroups={smartGroups}
            userId={userId}
            loginUrl={loginUrl}
            smartGroupLinkText={smartGroupLinkText}
          />
        </section>
        {trackingAds?.print_url && <img src={trackingAds?.print_url} style={{ display: 'none' }} alt="" />}
        <Script src="https://http2.mlstatic.com/frontend-assets/frontend-viewability/viewability-script.2.1.0.js">
          {getNonceScript(nonce)}
        </Script>
      </div>
    </AndesProvider>
  );
};

module.exports = DesktopView;
